import { AUTH_GROUPS } from 'constants/index';

export function getRole(roles: string[]) {
    if (roles.includes(AUTH_GROUPS.ADMIN)) {
        return AUTH_GROUPS.ADMIN;
    } else if (roles.includes(AUTH_GROUPS.ACCOUNT_MANAGER)) {
        return AUTH_GROUPS.ACCOUNT_MANAGER;
    } else if (roles.includes(AUTH_GROUPS.UNDERWRITER)) {
        return AUTH_GROUPS.UNDERWRITER;
    } else if (roles.includes(AUTH_GROUPS.AGENT)) {
        return AUTH_GROUPS.AGENT;
    } else if (roles.includes(AUTH_GROUPS.CARRIER_REP)) {
        return AUTH_GROUPS.CARRIER_REP;
    } else if (roles.includes(AUTH_GROUPS.AUDIT_REP)) {
        return AUTH_GROUPS.AUDIT_REP;
    } else {
        return 'auth';
    }
}

export function getIsAdminRole(role: string) {
    return role === AUTH_GROUPS.ADMIN;
}

export function getIsRestrictedRole(role: string) {
    return role === AUTH_GROUPS.RESTRICTED;
}

export function getIsUnderwriterRole(role: string) {
    return role === AUTH_GROUPS.ADMIN || role === AUTH_GROUPS.UNDERWRITER;
}

export function getIsAgentRole(role: string) {
    return role === AUTH_GROUPS.AGENT;
}

export function getIsCarrierRepRole(role: string) {
    return role === AUTH_GROUPS.CARRIER_REP;
}

export function getIsAuditRepRole(role: string) {
    return role === AUTH_GROUPS.AUDIT_REP;
}

export function getIsAccountManagerRole(role: string) {
    return role === AUTH_GROUPS.ADMIN || role === AUTH_GROUPS.ACCOUNT_MANAGER;
}

export function getIsLumenRole(role: string) {
    return (
        role === AUTH_GROUPS.ACCOUNT_MANAGER ||
        role === AUTH_GROUPS.ADMIN ||
        role === AUTH_GROUPS.UNDERWRITER ||
        role === AUTH_GROUPS.AUDIT_REP
    );
}

export function getRolesContain(userRoles: string[], candidateRoles: string[]) {
    return intersect(userRoles, candidateRoles).length > 0;
}

const intersect = (a: any[], b: any[]) => {
    const setA = new Set(a);
    const setB = new Set(b);
    const intersection = new Set([...Array.from(setA)].filter((x) => setB.has(x)));
    return Array.from(intersection);
};
